<template>
  <v-card class="oderon-card">
    <div class="compact-bar">
      <v-btn icon @click="$emit('reload')">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <div class="title">Vídeos já recebidos</div>
      <v-spacer />
      <div class="subtitle mr-4">Horários em {{ tzSubtitle }}</div>
      <OMenuButton icon="mdi-camera" :menuOpts="menuOpts" />
    </div>

    <OLoadingLine absolute :value="loader.isLoading" />

    <OJsonDialog ref="jsonDialog" />
    <MediaDialog ref="mediaDialog" />

    <div v-if="unixTimeGroups != null">
      <OJumbo
        question
        v-if="unixTimeGroups.length == 0"
        message="Não existem dados para o filtro informado."
      />

      <ThumbGroupList :groups="unixTimeGroups" @itemClicked="showItemDetails" />
    </div>
    <v-card-text v-if="loader.error">
      <v-alert icon="$error" color="red">{{ loader.error }}</v-alert>
    </v-card-text>
  </v-card>
</template>

<script>
import { tzSubtitle } from './tz-offset.js'
import Loader from 'oderon-vue/models/Loader.mjs'
import ThumbGroupList from 'oderon-vue/cpts/media/ThumbGroupList.vue'
import makeCameraTimeline from 'oderon-vue/cpts/media/camera-timeline-grouper.js'
import { go } from '@/models'
import utils from 'oderon-commons/src/utils.js'
import OJsonDialog from 'oderon-vue/cpts/dialogs/OJsonDialog.vue'
import MediaDialog from './MediaDialog.vue'

async function fetchItems({ cameraDef, date }) {
  if (cameraDef == null || cameraDef.imei == null)
    throw new Error('Falta o IMEI para buscar itens')

  if (date == null) throw new Error('Falta a data para buscar itens')

  let ps = {
    imei: cameraDef.imei,
    imeis: cameraDef.imei,
    fromDate: utils.sod(date),
    untilDate: utils.sod(date, 1),
    limit: 10000,
    order: 'timestamp desc, id desc'
  }

  let setUrl = (media) => (media.url = '/media/' + media.s3key)

  if (cameraDef.model == 'jc371') {
    let { rows: alarms } = await go.get('/cameras/jimi2/alarms', ps)
    let { rows: medias } = await go.get(`/cameras/jimi2/camera-files`, ps)
    medias.forEach(setUrl)
    return { medias, alarms }
  } else {
    let { rows: alarms } = await go.get('/cameras/jimi1/alarms', ps)
    let { rows: medias } = await go.get('/cameras/jimi1/video-files', ps)
    medias.forEach((x) => {
      if ( x.extension == 'ts' || x.extension == 'mp4' ) x.type = 'video'
      if ( x.extension == 'jpg' || x.extension == 'jpeg' ) x.type = 'image'
    })
    medias.forEach(setUrl)
    return { medias, alarms }
  }
}

async function sendSnapshotCommand({ cameraDef, channel }) {
  if (cameraDef == null || cameraDef.imei == null)
    throw new Error('Falta o IMEI para pedir snapshot')

  if (channel == null) throw new Error('Falta channel')

  if (cameraDef.model != 'jc371') return null

  return await go.post('/cameras/jimi2/upload-requests/snapshot', {
    imei: cameraDef.imei,
    channel
  })
}

export default {
  expose: ['reload'],
  components: { OJsonDialog, ThumbGroupList, MediaDialog },
  props: {
    cameraDef: {},
    date: {}
  },
  data() {
    return {
      tzSubtitle,
      loader: new Loader(),
      unixTimeGroups: null
    }
  },
  computed: {
    menuOpts() {
      let texts = ['Câmera Frontal', 'Câmera Interna', 'Câmera Extra']
      let result = texts.map((text, i) => {
        return {
          text,
          disabled: this.cameraDef.model != 'jc371',
          onClick: () => this.takePicture(i + 1)
        }
      })

      return result
    }
  },
  methods: {
    async reload() {
      return await this.loader.follow(async () => {
        let { alarms, medias } = await fetchItems({
          cameraDef: this.cameraDef,
          date: this.date
        })

        // Agrupa os alarmes, eventos e medias, criando uma timeline
        // com grupos de itens que caem no mesmo segundo (unixTime)
        let unixTimeGroups = makeCameraTimeline({
          alarms,
          medias,
          events: []
        })

        this.unixTimeGroups = unixTimeGroups
      })
    },
    showItemDetails(row) {
      this.$refs.mediaDialog.open(row)
    },
    async takePicture(channel) {
      return await this.loader.follow(async () => {
        return sendSnapshotCommand({
          cameraDef: this.cameraDef,
          channel
        })
      })
    }
  }
}
</script>

<style></style>
